module.exports = __webpack_public_path__ + "static/media/banner-cu.7ea9d7e8.png";